import { useBreakpoint } from './use-breakpoint';

export const MOBILE_BREAKPOINT = 768;

/**
 * Hook to detect if the viewport is mobile-sized.
 * Uses the 'md' Tailwind breakpoint (768px) as the threshold.
 * Delegates to useBreakpoint() internally.
 *
 * @example
 * ```tsx
 * const isMobile = useMobile();
 * return isMobile ? <MobileNav /> : <DesktopNav />;
 * ```
 */
export function useMobile(): boolean {
  return useBreakpoint().isMobile;
}
